import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForProductionSuggestion extends BaseModelAPI {
	static entity = 'pickingsupplyforproductionsuggestion';
	static entityName = 'pickingsupplyforproductionsuggestion';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingSupplyForProductionId = '';
			this.pickingSupplyForProduction = {};
			this.pickingSupplyForProductionDetailId = '';
			this.pickingSupplyForProductionDetail = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.qty = 0;
			this.isPicking = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}